const matches = [
    {
        team1: {
            id: 'mancity',
            score: 2
        },
        team2: {
            id: 'manunited',
            score: 1
        },
        events: [
            {
                minute: 24,
                event: 'Manchester controls the ball in midfield',
            }
        ],
        active: true,
    },
    {
        team1: {
            id: 'barcelona',
            score: 0
        },
        team2: {
            id: 'bvb',
            score: 1
        },
        events: [
            {
                minute: 56,
                event: 'Messi has an effort on goal',
            }
        ],
        active: true,
    },
    {
        team1: {
            id: 'bayern',
            score: 5
        },
        team2: {
            id: 'arsenal',
            score: 1
        },
        events: [
            {
                minute: 84,
                event: 'Bayern attack on left',
            }
        ],
        active: true,
    },
    {
        team1: {
            id: 'tottenham',
            score: 0
        },
        team2: {
            id: 'acmilan',
            score: 0
        },
        events: [
            {
                minute: 17,
                event: 'Manchester controls the ball in midfield',
            }
        ],
        active: true,
    },
    {
        team1: {
            id: 'chelsea',
            score: 0
        },
        team2: {
            id: 'acmilan',
            score: 2
        },
        events: [
            {
                minute: 17,
                event: 'Manchester controls the ball in midfield',
            }
        ],
        active: true,
    },
    {
        team1: {
            id: 'arsenal',
            score: 4
        },
        team2: {
            id: 'fiorentina',
            score: 0
        },
        events: [
            {
                minute: 24,
                event: 'Arsenal controls the ball in midfield',
            }
        ],
        active: false,
    },
    {
        team1: {
            id: 'barcelona',
            score: 0
        },
        team2: {
            id: 'bvb',
            score: 1
        },
        events: [
            {
                minute: 56,
                event: 'Messi has an effort on goal',
            }
        ],
        active: false,
    },
    {
        team1: {
            id: 'bayern',
            score: 5
        },
        team2: {
            id: 'arsenal',
            score: 1
        },
        events: [
            {
                minute: 84,
                event: 'Bayern attack on left',
            }
        ],
        active: false,
    },
    {
        team1: {
            id: 'liverpool',
            score: 1
        },
        team2: {
            id: 'acmilan',
            score: 0
        },
        events: [
            {
                minute: 17,
                event: 'Manchester controls the ball in midfield',
            }
        ],
        active: false,
    },
    {
        team1: {
            id: 'juventus',
            score: 1
        },
        team2: {
            id: 'arsenal',
            score: 3
        },
        events: [
            {
                minute: 17,
                event: 'Manchester controls the ball in midfield',
            }
        ],
        active: false,
    }
];

export default matches